import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import BgPattern from '~/landing/components/BgPattern'
import FeatureSection from '~/start/components/FeatureSection'
import { Breakpoint, useCheckBreakpoint } from '~/utils/useBreakpoint'

export default function MindSection(): React.ReactElement {
  const { t } = useTranslation('landing')
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })

  return (
    <div className="relative flex flex-col justify-center items-center px-2 py-12 text-center text-white">
      <BgPattern />
      <ResponsiveImage
        className="absolute min-w-196 w-full max-w-302 ml-[600px] mt-40"
        height={886}
        imageClassName="object-contain"
        srcKey="landing/pad-pattern.png"
        width={1378}
      />
      <div className="z-10">
        <p className="text-md text-blue-pastel py-2">{t('mindAI.backed')}</p>
        <h1 className="text-h1 font-bold max-w-6xl leading-tight">
          {Trans({
            t,
            i18nKey: 'mindAI.title',
            components: { pink: <span className="text-blue-pastel" /> },
            children: t('sagaPrivate.title'),
          })}
        </h1>
        <div className="flex relative max-w-302 w-full pt-28 pb-12">
          <div className="flex flex-col w-full">
            <div className="relative p-9 max-w-175 ml-6">
              <div className="relative z-10 max-w-87.5 text-left ml-18 mt-1">
                <p className="text-blue-pastel text-6.5 font-bold whitespace-nowrap">{t('mindAI.map')}</p>
                <p>{t('mindAI.analyzeKnowledge')}</p>
              </div>
              <ResponsiveImage
                className="absolute top-0 left-0 min-w-168"
                height={230}
                imageClassName="min-w-168"
                srcKey="landing/text-box-1.png"
                width={800}
              />
              <ResponsiveImage
                className="absolute top-2 ml-14 min-w-20 z-10"
                height={32}
                imageClassName="min-w-20"
                srcKey="landing/mini-box-2.png"
                width={100}
              />
              <ResponsiveImage
                className="absolute top-0 -right-72 min-w-20 z-10"
                height={32}
                imageClassName="min-w-20"
                srcKey="landing/mini-box-2.png"
                width={100}
              />
            </div>
            <div className="relative p-5 max-w-175">
              <div className="relative z-10 max-w-100 text-left ml-16">
                <p className="text-blue-pastel text-6.5 font-bold">{t('mindAI.personalizesLearning')}</p>
                <p>{t('mindAI.personalizedRecipes')}</p>
              </div>
              <ResponsiveImage
                className="absolute top-0 -left-8 min-w-75"
                height={160}
                imageClassName="min-w-75"
                srcKey="landing/text-box-2.png"
                width={710}
              />
              <ResponsiveImage
                className="absolute -bottom-2 right-40 min-w-20 z-10"
                height={32}
                imageClassName="min-w-20"
                srcKey="landing/mini-box-4.png"
                width={100}
              />
              <ResponsiveImage
                className="absolute top-15 -left-25 min-w-20"
                height={32}
                imageClassName="min-w-20"
                srcKey="landing/mini-box-2.png"
                width={100}
              />
            </div>
            <div className="relative p-9 max-w-175 ml-30">
              <div className="relative z-10 max-w-100 text-left ml-18">
                <p className="text-blue-pastel text-6.5 font-bold">{t('mindAI.adaptsRealTime')}</p>
                <p>{t('mindAI.constantlyLearning')}</p>
              </div>
              <ResponsiveImage
                className="absolute top-0 left-0 min-w-168"
                height={230}
                imageClassName="min-w-168"
                srcKey="landing/bg-image-1.png"
                width={800}
              />
            </div>
          </div>
          <ResponsiveImage
            className="absolute z-10 min-w-196 ml-[400px] -top-16"
            height={800}
            srcKey="landing/mind-ai-v2.png"
            width={800}
          />
        </div>
        <div className="flex">
          <FeatureSection isMobile={isMobile} />
        </div>
      </div>
    </div>
  )
}
